var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7,2H6.3A4.31,4.31,0,0,0,2,6.3V17.7A4.31,4.31,0,0,0,6.3,22H17.7A4.31,4.31,0,0,0,22,17.7V6.3A4.31,4.31,0,0,0,17.7,2ZM20,6.3V17.7A2.3,2.3,0,0,1,17.7,20H6.3A2.3,2.3,0,0,1,4,17.7V6.3A2.3,2.3,0,0,1,6.3,4H17.7A2.3,2.3,0,0,1,20,6.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12,14.85a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,12.12,14.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22,6.35A3.84,3.84,0,0,0,8.52,8.8l-.14.34,2,1,.17-.39a1.77,1.77,0,0,1,1.66-1.19c.73,0,1.2.34,1.2.86s-.23.57-.7.94c-.12.09-.24.18-.34.27A3,3,0,0,0,11,13.46v.76h2.25v-.64c0-.85.15-1,1.12-1.68a3,3,0,0,0,1.43-2.55C15.76,7.56,14.33,6.35,12.22,6.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSquare);
export default __webpack_public_path__ + "static/media/help-square.1fc4d27e4371533eccbc550ad5721392.svg";
export { ForwardRef as ReactComponent };